import { Form, Select } from 'antd';
import momentTimeZone from 'moment-timezone';
const timeZoneList = momentTimeZone.tz.names();

export const Locale = () => {
	return (
		<div>
			<h1 className="text-2xl font-bold">Preferences Yes</h1>
			<Form.Item
				label="Timezone"
				name="timeZone"
				rules={[{ required: true, message: 'Please select your timezone!' }]}
			>
				<Select
					showSearch
					data-testid="timezone-select"
					placeholder="Select a time zone"
					filterOption={(input, option) =>
						(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
					}
					options={timeZoneList.map((zone) => ({ label: zone, value: zone }))}
				/>
			</Form.Item>
		</div>
	);
};
